import Head from 'next/head';

interface LocalBusinessSchemaProps {
  locale: string | undefined;
}

const schemas: { [key: string]: object } = {
  au: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Dresden Vision Australia',
    url: 'https://dresden.vision/au',
    image: 'https://cdn.dresden.vision/static-images/logo.png',
    telephone: '+61 2 5300 3003',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '278 King Street, Newtown',
      addressLocality: 'Sydney',
      addressRegion: 'NSW',
      postalCode: '2042',
      addressCountry: 'AU',
    },
    areaServed: 'AU',
    inLanguage: 'en-AU',
    sameAs: [
      'https://www.facebook.com/dresdenvision',
      'https://www.instagram.com/dresdenvision',
    ],
  },
  ca: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Dresden Vision Canada',
    url: 'https://dresden.vision/ca',
    image: 'https://cdn.dresden.vision/static-images/logo.png',
    telephone: '+1 647 424 4288',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '599 College St',
      addressLocality: 'Toronto',
      addressRegion: 'ON',
      postalCode: 'M5V 2B6',
      addressCountry: 'CA',
    },
    areaServed: 'CA',
    inLanguage: 'en-CA',
    sameAs: [
      'https://www.facebook.com/dresdenvision',
      'https://www.instagram.com/dresdenvisionca',
    ],
  },
  nz: {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Dresden Vision New Zealand',
    url: 'https://dresden.vision/nz',
    image: 'https://cdn.dresden.vision/static-images/logo.png',
    telephone: '+64 800 447 111',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Auckland',
      addressLocality: 'Auckland',
      addressRegion: 'AUK',
      postalCode: '1010',
      addressCountry: 'NZ',
    },
    areaServed: 'NZ',
    inLanguage: 'en-NZ',
    sameAs: [
      'https://www.facebook.com/dresdenvision',
      'https://www.instagram.com/dresdenvision',
    ],
  },
};

const LocalBusinessSchema: React.FC<LocalBusinessSchemaProps> = ({ locale }) => {
  if (!locale || !schemas[locale]) {
    return null; // Don't render schema if locale is not AU, CA, or NZ
  }

  const schemaData = schemas[locale];

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

export default LocalBusinessSchema; 